const directives = {
  // 按钮防抖
  debounce: {
    inserted(el, binding) {
      el.addEventListener('click', () => {
        if (!el.disabled) {
          el.disabled = true;
          setTimeout(() => {
            el.disabled = false;
          }, binding.value || 400);
        }
      });
    },
  },
  // 长按事件
  longTouch: {
    bind(el, binding) {
      let timer = null;
      el.addEventListener('touchstart', () => {
        if (!timer) {
          timer = setTimeout(() => {
            //执行长按功能函数
            if (binding.value && typeof binding.value === 'function') {
              binding.value();
            }
          }, 500);
        }
      });
      el.addEventListener('touchend', () => {
        timer && clearTimeout(timer);
        timer = null;
      });
    },
  },
};

export default directives;
